import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from "jalali-moment";
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SubsidiaryCompanyAgentService } from 'src/app/services/http/business/subsidiary/subsidiary-company-agent.service';
import { environment } from 'src/environments/environment.prod';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-subsidiary-company-agent-entry',
  templateUrl: './subsidiary-company-agent-entry.component.html',
  styleUrls: ['./subsidiary-company-agent-entry.component.css']
})
export class SubsidiaryCompanyAgentEntryComponent implements OnInit {
  form: FormGroup;
  errors = new Array();
  userInfo: string;
  errObject: any;
  showSubmit: boolean = false;
  isMain: boolean = true;
  showTable: boolean = false;
  nationalCodeform: FormGroup;
  param: string[];
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private accountService: AccountService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private subsidiaryCompanyAgentService: SubsidiaryCompanyAgentService,
    private dialogRef: MatDialogRef<SubsidiaryCompanyAgentEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    if (this.data.Id && this.data.PersonEncryptId) {
      this.formControl();
      this.showSubmit = true;

    } else {
      this.createNaCodeForm();
    }
  }

  formControl() {

    this.form = this.fb.group({
      Id: [this.data && this.data["Id"] ? this.data["Id"] : 0],
      PersonEncryptId: [
        this.data && this.data["PersonEncryptId"] ?
          this.data["PersonEncryptId"] : null,
      ],
      RoleName: [
        this.data && this.data["RoleName"] ?
          this.data["RoleName"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(1)
        ])
      ],
      PhoneNumber: [
        this.data && this.data["PhoneNumber"] ?
          this.data["PhoneNumber"].toString() : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(11),
          // Validators.maxLength(12),
          // Validators.pattern("^([0-9][0-9]{9})?$")
        ])
      ],
      IsMain: [false],
      StartDate: [
        this.data && this.data["StartDate"] ?
          this.data["StartDate"] : null,
        Validators.required
      ],
      EndDate: [
        this.data && this.data["EndDate"] ?
          this.data["EndDate"] : null,
        Validators.required
      ],
    });

  }

  createNaCodeForm() {
    this.nationalCodeform = this.fb.group({
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ]
    });
  }
  getUserInfo(data: any) {

    this.errors = new Array();
    this.accountService.getSimpleUserInfo(data.NationalCode).subscribe(
      res => {
        this.formControl();
        this.form.controls["PersonEncryptId"].patchValue(res.PersonEncryptId);
        this.showSubmit = true;
        this.userInfo = res.FullName;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }


  submit(form: any) {

    this.errors = new Array();
    if (!form.IsMain && form.StartDate) {
      form.StartDate = moment
        .from(form.StartDate, "en")
        .utc(true)
        .format(environment.dateFormat);
      form.EndDate = moment
        .from(form.EndDate, "en")
        .utc(true)
        .format(environment.dateFormat);
    } else {
      form.StartDate = null;
      form.EndDate = null;
    }
    form["CustomerId"] = this.data.CustomerId;
    if (this.data && this.data.Id) {
      this.subsidiaryCompanyAgentService.customerAgentEdit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    } else {

      this.subsidiaryCompanyAgentService.customerAgentAdd(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
